export const locationMap = () => ({
    mapWrapper: {
        paddingTop: '12px',
        width: '100%',
        height: '500px'
    }
});
